import styled from 'styled-components'

import Image from 'components/Image'
import theme from 'theme_'
import { TableWithPaginationWrapper } from 'components/Table/styles'

export const StyledTableInnerWrapper = styled.div`
  @media ${theme.devices.tablet} {
    min-width: 1000px;
  }
`

export const StyledTableOuterWrapper = styled(TableWithPaginationWrapper)`
  @media ${theme.devices.tablet} {
    margin-bottom: 24px;
    box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.02);
    border-radius: 8px;
  }
`

export const StyledProfileThumbnail = styled(Image)`
  width: auto;
  height: 27px;
  object-fit: cover;
  @media ${theme.devices.tablet} {
    height: 40px;
  }
`

export const StyledProfileDevices = styled.div`
  word-break: break-all;
`
